import { render } from "./PrivacyView.vue?vue&type=template&id=1720d8ea&scoped=true"
const script = {}

import "./PrivacyView.vue?vue&type=style&index=0&id=1720d8ea&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1720d8ea"]])

export default __exports__